import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import fetchBooks from "../redux/books/thunk/fetchBooks";
import BookCard from "./BookCard";

const BookList = () => {
  const filters = useSelector((state) => state.filters);
  const books = useSelector((state) => state.books);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchBooks);
  }, [dispatch]);

  const filterByStatus = (book) => {
    switch (filters.status) {
      case "Featured":
        return book.featured;

      default:
        return true;
    }
  };

  const filterBySearch = (book) => {
    return book.name.toLowerCase().includes(filters.search.toLowerCase());
  };

  return (
    <div className="lws-bookContainer">
      {books.length > 0
        ? books
            .filter(filterByStatus)
            .filter(filterBySearch)
            .map((book) => <BookCard book={book} key={book.id} />)
        : "You have no book"}
    </div>
  );
};

export default BookList;
